import { Col, Form, Radio, Row, Select } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { deleteRequest, getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { useRouteNameChanges } from "../../feature/RouteNameProvider";

const { Option } = Select;

const ConfirmDriverAssignment = ({
  closeModal,
  record,
  setState,
  routeIds,
  updateDriverAssignment,
  setSelectedRow,
  setRouteIds,
  getCurrentLocation,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const initialState = {
    packages: [],
    route_assign: true,
    driver: null,
    route_id: null,
    old_route_id: [],
  };

  const [state, stateDriver] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [routeName, setRouteName] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [recordId, setRecordId] = useState([]);
  const { driverState, setDriverState } = useRouteNameChanges();

  const getDriverName = async () => {
    try {
      const response = await getRequest("employee/drivers-list/");
      const { data } = response.data;
      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
    } catch (error) {
      console.log("Error fetching driver list:", error);
    }
  };
  useEffect(() => {
    getDriverName();
  }, []);
  const handleDriverSelectChange = (value) => {
    stateDriver((prevState) => ({
      ...prevState,
      driver: value,
      route_id: null,
    }));
    formRef.current.setFieldsValue({ driver: value, route_id: null });
    setRouteName([]);
    getRouteByDriver(value);
  };
  const handleRouteNameSelectChange = (value) => {
    stateDriver((prevState) => ({
      ...prevState,
      route_id: value,
    }));
    formRef.current.setFieldsValue({ route_id: value });
  };

  const getRouteByDriver = async (id) => {
    const routeResponse = await getRequest(
      "route/route-name-by-driver/?driver_id=" + id
    );
    setRouteName(routeResponse?.data?.data);
  };

  const handleCancel = (value) => {
    stateDriver(initialState);
    formRef.current.setFieldsValue(initialState);
    closeModal();
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const backToList = () => {
    stateDriver(initialState);
    formRef.current.setFieldsValue(initialState);
    closeModal();
  };

  const handleOptionChangeRote = (name, value) => {
    stateDriver({ ...state, [name]: value });

    if (name === "route_assign") {
      if (value === true) {
        // Show driver and route dropdowns
        stateDriver((prevState) => ({
          ...prevState,
          driver: null,
          route_id: null,
        }));
      } else {
        // Hide driver and route dropdowns
        stateDriver((prevState) => ({
          ...prevState,
          driver: null,
          route_id: null,
        }));
        formRef.current.setFieldsValue({ driver: null, route_id: null });
      }
    }
  };

  //handle Form Submit
  const handleSubmit = async () => {
    setBtnLoading(true);
    const location = await getCurrentLocation();
    
    
    const payload = {
      ...(state.route_assign && {
        // route_assign: state.route_assign,
        driver: state.driver,
        route_id: state.route_id,
        packages: [record.id],
        old_route_id: record?.route_id ? [record.route_id] : [],
        // latitude: location?.latitude,
        // longitude: location?.longitude,
    //        ...(location?.latitude != null && {
    //   latitude: location.latitude,
    // }),

    // ...(location?.longitude != null && {
    //   longitude: location.longitude,
    // }),


    ...(location?.latitude!=null && {
      latitude:location.latitude,
    }),
    ...(location?.longitude!=null) &&{
      longitude:location.longitude,
    }
   

      }),
    };
    const recordId = record.id;
    setRecordId(recordId);
    try {
      
      let apiResponse;
      if (state.route_assign) {
        apiResponse = await postRequest("assign-package-to-driver/", payload);
      } else {
        // apiResponse = await deleteRequest(`assign-package-to-driver/${recordId}/`);
        apiResponse = await deleteRequest(
          `assign-package-to-driver/${recordId}/unassign-single-package/`
        ,{
          latitude: location?.latitude,
          longitude: location?.longitude,
        });
      }
      closeModal();
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          state.route_assign
            ? t("Assign Package To Driver Successfully")
            : t("Unassign Package To Driver Successfully")
        );
        setSelectedRow([]);
        setRouteIds([]);
        updateDriverAssignment(
          record.id,
          apiResponse?.data?.data?.driver,
          apiResponse?.data?.data?.id,
          apiResponse?.data?.data?.driver_name
        );
        stateDriver(initialState);
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        closeModal();
        // setState({
        //   ...state,
        //   search: "",
        // });
        setState((prevState) => ({
          ...prevState,

          search: "",
        }));
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      closeModal();
      setState((prevState) => ({
        ...prevState,

        search: "",
      }));
      stateDriver(initialState);
      formRef.current.setFieldsValue(initialState);
    }
  };

  return (
    <>
      <div className="optimize-modal">
        <Form ref={formRef} onFinish={handleSubmit}>
          <Row gutter={[10]}>
            <Col xs={24} sm={12} md={8} lg={6} className="">
              <Form.Item name="route_assign" label="" initialValue={true}>
                <Radio.Group
                  onChange={(e) =>
                    handleOptionChangeRote("route_assign", e.target.value)
                  }
                  style={{ display: "flex", width: "max-content" }}
                  value={state.route_assign}
                >
                  <Radio style={{ display: "flex" }} value={true}>
                    Adding To existing Route
                  </Radio>
                  <Radio value={false}>Unassigned</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={12} className="TextFeild">
              {state.route_assign && (
                <Form.Item
                  name="driver"
                  rules={[
                    {
                      required: true,
                      message: t("Please select a driver!"),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("val_driver")}
                    showArrow
                    showSearch
                    value={driverState?.driver}
                    optionFilterProp="children"
                    onChange={handleDriverSelectChange}
                  >
                    {driverList?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>

            <Col xs={24} md={12} className="TextFeild">
              {state.route_assign && (
                <Form.Item name="route_id">
                  <Select
                    placeholder={t("Select route")}
                    showArrow
                    showSearch
                    optionFilterProp="children"
                    value={driverState?.route_id}
                    onChange={handleRouteNameSelectChange}
                  >
                    {routeName?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.route_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            <Col xs={24} className="modlbtnrow ">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="button"
                size="medium"
                label="Cancel"
                onClick={handleCancel}
              />

              <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                htmlType="submit"
                label={t("save")}
                loading={btnLoading}
              />
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};
ConfirmDriverAssignment.propTypes = {
  closeModal: PropTypes.func,
  zoneList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      zone_name: PropTypes.string,
    })
  ),
  setIsModalVisible: PropTypes.func,
  materialMasterId: PropTypes.number,
  modalKey: PropTypes.bool,
  fileList: PropTypes.array,
  setFileList: PropTypes.func,
  stateDriverM: PropTypes.func,
  setState: PropTypes.func,
  reload: PropTypes.func,
  setReload: PropTypes.func,
  updateDriverAssignment: PropTypes.func,
  record: PropTypes.object.isRequired,
  setSelectedRow: PropTypes.array,
  setRouteIds: PropTypes.array,
  routeIds: PropTypes.array,
  getCurrentLocation: PropTypes.func,
};
export default ConfirmDriverAssignment;
